/** @jsxImportSource @emotion/react */

import { lazy, ReactNode, Suspense } from 'react';
import { useSelector } from 'react-redux';
import {
  getUserIdSelector,
  getUserRoleSelector,
} from '../../state-manager/selectors/appSelectors';
import Loader from '../commons/Loader';

// Split out so clinicians never download the terms document or its screen.
const PatientTerms = lazy(
  () => import(/* webpackChunkName: "patient-terms" */ './PatientTerms'),
);

// Patients see nothing of the portal until they have accepted the current
// version of the Terms of Use. Clinicians and admins pass straight through.
export default function PatientTermsGate({
  children,
}: {
  children: ReactNode;
}) {
  const role = useSelector(getUserRoleSelector);
  const userId = useSelector(getUserIdSelector);

  if (!role) {
    return <Loader />;
  }
  if (role !== 'patient') {
    return <>{children}</>;
  }
  return (
    <Suspense fallback={<Loader />}>
      <PatientTerms userId={userId}>{children}</PatientTerms>
    </Suspense>
  );
}
